/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_appsync_graphqlEndpoint": "https://64bbjjb3zfep5bld3v7xebnx4e.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-gihzemytq5fjjptqakw3crtsni",
    "aws_cognito_identity_pool_id": "us-west-1:5c67cb92-ebc1-4b5f-a9d8-32c78de0d7a5",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_y7rsskX32",
    "aws_user_pools_web_client_id": "4n3t3g648grausa0dr0imk0v8e",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "scout-data-assets61552-dev",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;
